import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Package } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { ProductPricingCalculator } from '../../components/product-pricing/ProductPricingCalculator';
import { SupportHoursCard } from '../../components/product-pricing/SupportHoursCard';

export default function ProductPricingTab() {
  const { estimateId } = useParams();
  const [savedKey, setSavedKey] = useState(0);
  const [pricingKey, setPricingKey] = useState(0);
  return (
    <div className="space-y-4" data-testid="product-pricing-tab">
      <div>
        <h2 className="text-base md:text-lg font-semibold text-[#0F2040] flex items-center gap-2"><Package className="w-4 h-4 text-[#4ABFCF]" /> Product pricing</h2>
        <p className="text-xs text-slate-500">Platform subscription for this customer — package, allowances, term and discretionary discounts, per-year schedule, invoicing and margin blended with the implementation estimate.</p>
      </div>
      <Card className="border-slate-200">
        <CardContent className="p-5">
          <ProductPricingCalculator estimateId={estimateId} onSaved={() => setSavedKey((k) => k + 1)} reloadKey={pricingKey} />
        </CardContent>
      </Card>
      <SupportHoursCard estimateId={estimateId} refreshKey={savedKey} onPricingChanged={() => setPricingKey((k) => k + 1)} />
    </div>
  );
}
